"use client";

import type { GetUserQuery } from "@frontend/roz-sdk-core";
import { useEffect } from "react";

import { useUser } from "@/provider";
import { ModalContentType } from "@/types";
import { useModalStore } from "@/ui-state";

type PersonalDataUser = NonNullable<GetUserQuery["me"]> & {
  agreement?: unknown;
};

export const PersonalDataListener = () => {
  const { user, isLoading } = useUser<PersonalDataUser>();
  const { open, setType } = useModalStore();

  useEffect(() => {
    if (isLoading || !user) {
      return;
    }

    if (user.agreement) {
      return;
    }

    setType(ModalContentType.personalData);
    open();
  }, [isLoading, open, setType, user]);

  return null;
};
